import React, { FC, ReactNode } from 'react'
import { IconS24MapMagnifier48 } from '@is24/cosma-ui-icons'

export const LocationSolarHighlighterIcon: FC<ReactNode> = () => {
  return (
    <IconS24MapMagnifier48 data-testid='location-solar-highlighter-icon' width={128} height={128} viewBox='0 0 38 38' />
  )
}
